import React from "react";

type Props = {
    className?: string;
};

export default function RedX(props: Props) {
    return (
        <svg
            className={props.className}
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
        >
            <g fill="none" fillRule="evenodd">
                <g>
                    <g transform="translate(-316 -778) translate(316 778)">
                        <circle cx="9" cy="9" r="9" fill="var(--red)" />
                        <g stroke="var(--white)">
                            <path d="M0.706 0.757L9.397 9.447" transform="translate(4 4)" />
                            <path
                                d="M0.706 0.757L9.397 9.447"
                                transform="translate(4 4) matrix(-1 0 0 1 10.103 0)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
